import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { isEmpty } from 'lodash';

import messages from './messages';

import StatisticsHeader from './components/StatisticsHeader';
import BlocksList from './components/BlocksList';
import CSVExportFooter from './components/CSVExportFooter';
import {
    sortBlocksByStartDate,
    filterDisplayableBlocks,
    calculateBlockTotals,
    calculateAllocationsTotals,
} from './utils';

const Container = styled.div`
    width: 100%;
    padding: 15px;

    & > *:not(:last-child) {
        margin-bottom: 10px;
    }
`;

const MessageContainer = styled(Container)`
    text-align: center;
`;

const InventoryBlocks = ({ currency, data }) => {
    const [blocks, setBlocks] = useState([]);
    const [totals, setTotals] = useState({});

    const formatData = () => {
        const dataWithTotals = calculateAllocationsTotals(data);
        const filteredAndSortedData = sortBlocksByStartDate(filterDisplayableBlocks(dataWithTotals));
        setBlocks(filteredAndSortedData);
        setTotals(calculateBlockTotals(filteredAndSortedData));
    };

    useEffect(() => {
        if (!isEmpty(data)) {
            formatData();
        } else {
            setBlocks([]);
            setTotals({});
        }
    }, [data]);

    const renderNoDataMessage = () => (
        <MessageContainer>
            <FormattedMessage {...messages.noData} />
        </MessageContainer>
    );

    if (blocks.length === 0) {
        return renderNoDataMessage();
    }
    return (
        <Container>
            <StatisticsHeader {...totals} currency={currency} />
            <BlocksList blocks={blocks} currency={currency} />
            <CSVExportFooter blocks={blocks} currency={currency} />
        </Container>
    );
};

export default InventoryBlocks;
